$(function () {
  var nextbtn = $('#nextpage')
  var prevbtn = $('#prevpage')
  //请求到的信息列表
  function getnews(page) {
    API.getNews({
      page: page || 1,
      page_size: 12
    }, function(res) {
      if (!res[0]) {
        var res = res[1]
        if (res.count > 0) {
          var page ='';
          res.results.forEach(function(v,i) {
            var a = v.summary.length > 50 ? "..." : "";
            page +=`
            <li>
              <a href="/@/news/newsdetail.html?id=${v.id}">
                <div class="imgbox">
                  <div><img src="${v.image_url}" alt=""></div>
                </div>
                <div class="text">
                  <h3>${v.title}</h3>
                  <p>${v.summary.substr(0, 50)+a}</p>
                  <span>${new Date(v.created_time).format('yyyy-MM-dd')}</span>
                  <span class="from">来源 : ${v.source || '华瑞物联'}</span>
                </div>
              </a>
            </li>`
          })
          $('#news-list').html(page)
          clipimg()
        }
        var next = res.next ? getpageNum(res.next, 'page') : ''
        var prev = res.previous ? getpageNum(res.previous, 'page') : ''      
        nextbtn.attr('data-page', next)
        prevbtn.attr('data-page', prev)
        if (!next) {
          nextbtn.hide()
        } else {
          nextbtn.show()
        }
        if (!prev) {
          prevbtn.hide()
        } else {
          prevbtn.show()
        }                
      }
    })
  }

  function clipimg() {
    $('#news-list img').each(function (i, v) {
      $(v.parentNode).css({
        'height': $(v).width() * 0.66
      })
    })
  }

  function getpageNum(string, name) {
    var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)")
    var params = '?'+string.split('?')[1]
    var r = params.substr(1).match(reg);
    if (r != null) return unescape(r[2]);
    return 1;  // prev为1就默认没了 
  }
  $('.pagebtn').each(function(i, v) {
    $(v).on('click', function() {
      getnews($(v).attr('data-page'))
      $("html,body").animate({scrollTop: 0}, 300);      
    })
  })


  getnews()
})